import {HTTP} from '../../utils/http-base';
import store from 'store';
import router from '@/router';

// initial state
const state = {
  mapEditable : true,
  areaDetailsPanel : false,
  areaReviewPanel : false,
  centerPolygon : false,
  savedAreas : [],
  areasLoading : false,
  areaCreator : {

  },
  mapData : {
    center: {lat: 52.9548, lng: -1.15047},
    zoom: 8,
    mapTypeControl: true,
    mapTypeId: 'roadmap',
    zoomControl:false,
    scaleControl: false,
    streetViewControl: false,
    rotateControl: false,
    fullscreenControl: false,
    edited: null,
    polygonsList: [],
    currentMidx: null,
    drawingManager: null,
    showCustomMapControls : true,
    showMapSearchControls : true,
    mapSearchInput : '',
    description : '',
    maxZoom : 20,
  }
}

// getters
const getters = {
   mapCanEditAndInteract(state){
     return state.mapEditable
   },

   showAreaDetailsPanel(state){
    return state.areaDetailsPanel;
   },
   showAreaReviewPanel(state){
    return state.areaReviewPanel
   },
   centerPolygon(state){
    return state.centerPolygon
   },
   areaCreatorData(state){
    return state.areaCreator
   },
   savedAreas(state){
    return state.savedAreas;
   },
   areasLoading(state){
    return state.areasLoading;
   },
   mapData(state){
    return state.mapData;
   },
   canDraw(state){
    return state.drawingMode;
   },
   polyGonCreated(state){
     return state.mapData.polygonsList;
   }
}

// actions
const actions = {
  'CREATE_AREA' : ({commit, dispatch}, formData) => {
      return new Promise((resolve, reject) => {
        dispatch('setIsWaiting', {isWaiting : true, message : 'Please wait...'})
        commit('loadingAreas', true);
        // console.log(formData);
        HTTP.post('/api/areas', formData)
        .then((response) => {
          // console.log(response);
          let data = response.data;
          commit('loadingAreas', false);
          commit('addArea', data.data);
          commit('setLocalStorageArea',data.data);
          commit('activateReviewAreasPanel');
          commit('resetCreateArea');
          dispatch('setIsWaiting', {isWaiting : false, message : ''})
          router.push({ path: '/create/review-areas' })
          // console.log(data);
          resolve(data);
        })
        .catch((err) => {
          console.log(err);
          dispatch('setIsWaiting', {isWaiting : false, message : ''})
          commit('loadingAreas', false);
        
          reject(err);
        })
      })
  },

  getLocalStoredAreas : ({commit, rootState}) => {
    return new Promise((resolve, reject) => {

        let localAreaIds = store.get('topographicalapp-areas');

        if(!localAreaIds || localAreaIds.length == 0){ return }

        commit('loadingAreas', true);
        let queryString = localAreaIds.join("+");

        HTTP.get('/api/areas?areaIds=' + queryString)
        .then((response) => {
          // console.log(response);
           if(response.data.confirmation === 'success'){
              let areas = response.data.data;
              commit('activateReviewAreasPanel', true);
              commit('loadingAreas', false);
              commit('setAreas', areas);
              if(!rootState.user.isLoggedIn){
                
              }
              resolve(true);

           } else {
              resolve(false);
           }
        })
        .catch((err) => {
          commit('loadingAreas', false);
          reject(err);
        })
     })
  },

  deleteArea : ({commit}, areaId) => {
      return new Promise((resolve, reject) => {
          HTTP.delete('/api/areas/' + areaId)
        .then((response) => {
          let data = response.data;
          commit('removeAreaLocalStorage', areaId);
          commit('removeArea', areaId);
          resolve(data);
        })
        .catch((err) => {
          console.log(err);
          reject(err);
        })
      })
  },

  goToSurveyQuoteSummary : ({commit}, areaId) => {
    router.push({path : '/create/quote-summary'});
  }

}

// mutations
const mutations = {
  areaCreator(state, payload){
    // areaCreator.areaTitle = payload.createAreaTitle;
    // areaCreator.areaDescription = payload.createAreaDesc
    let areaCreator = Object.assign({}, state.areaCreator);
    state.areaCreator = {...areaCreator, ...payload}
  },
  navigateToAreaDetails(state){
    state.mapEditable = !state.mapEditable;
    state.areaDetailsPanel = !state.areaDetailsPanel;
    router.push({path : '/create/area-details'})
  },

  navigateToSelectArea(state){
    state.mapEditable = true;
    state.areaDetailsPanel = false;
    state.drawingMode = null;
    state.areaReviewPanel = false;
    router.push({path : '/create/select-area'})
  },

  centerPolygon(state){
    state.centerPolygon = !state.centerPolygon
  },

  activateReviewAreasPanel(state){
    state.mapEditable = false;
    state.drawingMode = null;
    state.areaDetailsPanel = false;
    state.areaReviewPanel = true;
  },

  closeReviewAreasPanel(state){
    state.areaReviewPanel = false;
    state.drawingMode = 'polygon';
    state.mapEditable = true;
  },

  setAreas(state, areas){

    state.savedAreas = areas;
  },

  removeAreas(state){
    state.savedAreas = [];
  },

  loadingAreas(state, boolean){
    state.areasLoading = boolean;
  },

  addArea(state, area){
    state.savedAreas.push(area);
  },

  updateMapCenter(state, position){
    state.mapData.center = position;
  },

  removeAllAreasLocalStorage(state, payload){
    store.set('topographicalapp-areas', payload);  
  },

  setLocalStorageArea(state, data){

    let areaId = data.areaId;
    let areas = store.get('topographicalapp-areas');
 
    if(areas == null){
      store.set('topographicalapp-areas', [areaId]);      
    } else {
      areas.push(areaId);
      store.set('topographicalapp-areas', areas);
    }
  },

  restartCreateAreaProcess(state){
    state.mapEditable = true;
    state.areaDetailsPanel = false;
    state.areaReviewPanel = false;
    state.drawingMode = 'polygon';
    state.mapData.polygonsList = [];
    router.push({path : '/create/select-area'})
  },

  resetCreateArea(state){
    state.mapEditable = true;
    state.areaDetailsPanel = false;
    state.areaReviewPanel = false;
    state.drawingMode = 'polygon';
    state.mapData.polygonsList = [];
  },

  removeArea(state, areaId){
    let newAreas = state.savedAreas.filter((area) => {
      return area.areaId !== areaId
    })
    state.savedAreas = newAreas;
    if(newAreas.length == 0){
      state.mapEditable = true;
      state.areaDetailsPanel = false;
      state.areaReviewPanel = false;
      state.drawingMode = 'polygon';
      state.mapData.polygonsList = [];
      router.push({ path: '/create/select-area' });
    }
  },

  removeAreaLocalStorage(state, areaId){
      let areas = store.get('topographicalapp-areas');
    
      if(areas){
        let newAreas = areas.filter((area) => {
          return area !== areaId;
        })
        store.set('topographicalapp-areas', newAreas);      
      } 
  },

  createPolygon(state, polygon){
    state.mapData.polygonsList = polygon;
  },

  deleteVertex(state, vertexPosition){
    state.mapData.polygonsList[0].splice(vertexPosition, 1);
  },
  removePolygon(state){
    state.mapData.polygonsList = [];
  }
}

export default {
  state,
  getters,
  actions,
  mutations
}


// WEBPACK FOOTER //
// ./src/store/modules/createArea.js